import { readZendeskSupportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { UserInfo } from "../entities/user-info";
import { HelpRepositoryInterface } from "./help-repository-interface";
import store from "@src/reducers/store";
import { SourceInfo } from "../entities/source-info";

export class HelpRepository implements HelpRepositoryInterface {
  getFaqUrl(): string {
    return readZendeskSupportUrlEnvVar();
  }

  getUserInfo(): UserInfo {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    // const context = useAuthContext();

    // const info = context?.userInfoForSupportTicket;

    const userInfoForSupportTicket =
      store.getState().yourSlice.customerInformationForSupportTicket;

    const { givenName, familyName, email, namespace } =
      userInfoForSupportTicket;

    return new UserInfo(email, namespace, givenName, familyName);
  }

  getSourceInfo(): SourceInfo {
    const userInfoForSupportTicket =
      store.getState().yourSlice.connectionView.source;

    const { name, dsn } = userInfoForSupportTicket;

    return new SourceInfo(name, dsn);
  }
}
